import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Lookup from './pages/Lookup';
import Results from './pages/Results';
import Login from './pages/Login';
import AdminDashboard from './pages/admin/AdminDashboard';
import TeacherForm from './pages/admin/TeacherForm';
import MessageSettings from './pages/admin/MessageSettings';
import LinkSettings from './pages/admin/LinkSettings';
import './App.css';

function App() {
  console.log("App rendering");
  return (
    <AuthProvider>
      <LanguageProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/" element={<Lookup />} />
              <Route path="/results/:reg_no" element={<Results />} />
              <Route path="/login" element={<Login />} />
              <Route 
                path="/admin" 
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/teacher" 
                element={
                  <ProtectedRoute>
                    <TeacherForm />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/teacher/:id" 
                element={
                  <ProtectedRoute>
                    <TeacherForm />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/messages" 
                element={
                  <ProtectedRoute>
                    <MessageSettings />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/links" 
                element={
                  <ProtectedRoute>
                    <LinkSettings />
                  </ProtectedRoute>
                } 
              />
            </Routes>
          </div>
        </Router>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;